import Vue from 'vue';


Vue.use({
  install(Vue) {
    Vue.prototype.downloadBase64 = function (fileData, fileName) {
      console.log(fileData);
      let image_data = atob(fileData.split(',')[1]);
      let arraybuffer = new ArrayBuffer(image_data.length);
      let view = new Uint8Array(arraybuffer);
      for (let i = 0; i < image_data.length; i++) {
        view[i] = image_data.charCodeAt(i) & 0xff;
      }
      try {
        var blob = new Blob([arraybuffer], {type: 'application/octet-stream'});
      } catch (e) {
        var bb = new (window.WebKitBlobBuilder || window.MozBlobBuilder);
        bb.append(arraybuffer);
        var blob = bb.getBlob('application/octet-stream');
      }

      let url = (window.webkitURL || window.URL).createObjectURL(blob);


      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    };
  }
});



// WEBPACK FOOTER //
// ./src/lib/downloadBase64.js